// ============================================
// CONFIGURATION DEBUG
// ============================================
const headerDebug = 0; // Mettre à 1 pour activer les logs de debug

// Mesurer la largeur du menu nav et injecter le breakpoint optimal
function calculateMenuBreakpoint() {
  try {
    if (headerDebug) console.log("🔄 Début du calcul du breakpoint menu...");

    const menu = document.querySelector(".header__inline-menu");
    const burger = document.querySelector(".header__icon--menu");

    if (!menu || !burger) {
      if (headerDebug) console.warn("⚠️ Menu ou burger non trouvé");
      return;
    }

    if (headerDebug) console.log("✅ Menu et burger trouvés");

    // Forcer l'affichage temporaire pour mesurer
    menu.style.display = "block";
    menu.style.visibility = "hidden";
    menu.style.position = "absolute";

    // Mesurer la largeur réelle du menu
    const menuWidth = menu.scrollWidth;
    const menuOffsetWidth = menu.offsetWidth;
    const menuComputedStyle = getComputedStyle(menu);
    const menuMarginLeft = parseFloat(menuComputedStyle.marginLeft) || 0;
    const menuMarginRight = parseFloat(menuComputedStyle.marginRight) || 0;

    // Espace libre minimum qu'on veut garder dans header__left
    // Si l'espace libre devient inférieur à cette valeur, on bascule sur le burger
    const FreeSpaceBreakPoint = 80; // px

    // Remettre en état normal
    menu.style.display = "";
    menu.style.visibility = "";
    menu.style.position = "";

    if (headerDebug) {
      console.log("📦 Mesure initiale du menu:");
      console.log("   └─ scrollWidth:", menuWidth + "px");
      console.log("   └─ offsetWidth:", menuOffsetWidth + "px");
      console.log("   └─ marginLeft:", menuMarginLeft + "px");
      console.log("   └─ marginRight:", menuMarginRight + "px");
    }

    // Lire les variables CSS
    const computedStyle = getComputedStyle(document.documentElement);
    const logoWidthStr = computedStyle.getPropertyValue("--logo-width").trim();
    const paddingLeftStr = computedStyle
      .getPropertyValue("--header-padding-left-desktop")
      .trim();

    // Lire le font-size de :root pour calculer correctement les rem en px
    const rootFontSize = parseFloat(computedStyle.fontSize) || 16;

    const logoWidth = parseInt(logoWidthStr) || 110;
    const paddingLeft = parseFloat(paddingLeftStr) * rootFontSize; // Convertir rem en px avec le bon ratio

    // Calculer le breakpoint avec la formule :
    // 50% width écran = padding-left + menu + marge sécu + (logo/2)
    // W/2 = paddingLeft + menuWidth + FreeSpaceBreakPoint + logoWidth/2
    // W = 2 × (paddingLeft + menuWidth + FreeSpaceBreakPoint + logoWidth/2)
    const optimalBreakpoint =
      2 * (paddingLeft + menuWidth + FreeSpaceBreakPoint + logoWidth / 2);

    // Stocker les valeurs dans des variables CSS
    document.documentElement.style.setProperty(
      "--menu-nav-width",
      `${menuWidth}px`
    );
    document.documentElement.style.setProperty(
      "--menu-breakpoint",
      `${optimalBreakpoint}px`
    );

    // Créer une règle CSS dynamique avec le breakpoint calculé
    const style = document.createElement("style");
    style.textContent = `
        @media screen and (min-width: ${optimalBreakpoint}px) {
          .header__inline-menu { display: block !important; }
          .header__icon--menu { display: none !important; }
        }
        @media screen and (max-width: ${optimalBreakpoint - 1}px) {
          .header__inline-menu { display: none !important; }
          .header__icon--menu { display: flex !important; }
        }
      `;
    document.head.appendChild(style);

    // Logs de debug
    if (headerDebug) {
      console.log("📊 === CALCUL DU BREAKPOINT HEADER ===");
      console.log("📏 Largeur du menu:", menuWidth + "px");
      console.log("🖼️  Largeur du logo:", logoWidth + "px");
      console.log(
        "📐 Font-size racine:",
        rootFontSize + "px (1rem = " + rootFontSize + "px)"
      );
      console.log(
        "📐 Padding-left var:",
        paddingLeftStr + " → " + paddingLeft + "px"
      );
      console.log("🆓 Marge de sécurité:", FreeSpaceBreakPoint + "px");
      console.log("");
      console.log("🧮 Formule breakpoint:");
      console.log("   W = 2 × (padding-left + menu + marge + logo/2)");
      console.log(
        "   W = 2 × (" +
          paddingLeft +
          " + " +
          menuWidth +
          " + " +
          FreeSpaceBreakPoint +
          " + " +
          logoWidth / 2 +
          ")"
      );
      console.log(
        "   W = 2 × " + (paddingLeft + menuWidth + FreeSpaceBreakPoint + logoWidth / 2)
      );
      console.log("   W = " + optimalBreakpoint + "px");
      console.log("");
      console.log(
        "🎯 Breakpoint calculé:",
        Math.round(optimalBreakpoint) + "px"
      );
      console.log("✅ Media queries injectées");
    }
  } catch (error) {
    console.error("❌ Erreur lors du calcul du breakpoint:", error);
  }
}

// Calculer et afficher l'espace restant dans header__left
function logHeaderLeftSpace() {
  if (!headerDebug) return;

  const headerLeft = document.querySelector(".header__left");
  const menu = document.querySelector(".header__inline-menu");

  if (!headerLeft || !menu) return;

  const headerLeftWidth = headerLeft.offsetWidth;
  const menuScrollWidth = menu.scrollWidth;
  const menuOffsetWidth = menu.offsetWidth;
  const menuVisible = window.getComputedStyle(menu).display !== "none";

  const remainingSpace = headerLeftWidth - menuScrollWidth;

  console.log(
    "🔍 === ESPACE HEADER__LEFT (largeur écran: " +
      window.innerWidth +
      "px) ==="
  );
  console.log("   Largeur header__left:", headerLeftWidth + "px");
  console.log("   Menu visible:", menuVisible ? "OUI" : "NON");
  console.log("   Largeur menu:", menuScrollWidth + "px");
  console.log("   ✨ Espace libre:", remainingSpace + "px");
  console.log("");
}

// Surveiller le redimensionnement de la fenêtre
let headerResizeTimeout;
window.addEventListener("resize", () => {
  // Debounce pour éviter trop de logs
  clearTimeout(headerResizeTimeout);
  headerResizeTimeout = setTimeout(() => {
    logHeaderLeftSpace();
  }, 200);
});

// Exécuter quand tout est chargé
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    calculateMenuBreakpoint();
    logHeaderLeftSpace();
  });
} else {
  calculateMenuBreakpoint();
  logHeaderLeftSpace();
}
